import appHeader from './index.vue'

appHeader.install = function (Vue) {
  Vue.component(appHeader.name, appHeader)
}

export default appHeader
